import { useEffect, useState } from "react";
import { LOGO_URL } from "../assets";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { href: "#servicios", label: "Servicios" },
  { href: "#beneficios", label: "Beneficios" },
  { href: "#proceso", label: "Proceso" },
  { href: "#nosotros", label: "Nosotros" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-[#EAEAEA]"
          : "bg-white/0 border-b border-transparent"
      }`}
    >
      <div className="nr-container flex items-center justify-between h-[88px] md:h-[100px]">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center"
          onClick={close}
        >
          <img
            src={LOGO_URL}
            alt="The Next Room"
            className="h-14 md:h-16 w-auto object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="font-sub text-[14px] text-[#111] hover:text-[#2E8E92] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#contacto"
            data-testid="navbar-cta"
            className="nr-btn nr-btn-primary hidden md:inline-flex"
          >
            Reservar llamada
          </a>
          <button
            type="button"
            aria-label="Abrir menú"
            data-testid="navbar-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden h-10 w-10 inline-flex items-center justify-center rounded-full border border-[#EAEAEA]"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden bg-white border-t border-[#EAEAEA]"
        >
          <div className="nr-container py-6 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={close}
                className="font-sub text-[15px] text-[#111]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contacto"
              onClick={close}
              data-testid="navbar-mobile-cta"
              className="nr-btn nr-btn-primary w-full"
            >
              Reservar llamada
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
